// SPDX-FileCopyrightText: OpenTalk GmbH <mail@opentalk.eu>
//
// SPDX-License-Identifier: EUPL-1.2
import SuspenseLoading from '../../commonComponents/SuspenseLoading/SuspenseLoading';

const SplashScreenPage = () => <SuspenseLoading />;

export default SplashScreenPage;
